/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidateMenuOrderItemsResultError } from './ValidateMenuOrderItemsResultError';
import {
    ValidateMenuOrderItemsResultErrorFromJSON,
    ValidateMenuOrderItemsResultErrorFromJSONTyped,
    ValidateMenuOrderItemsResultErrorToJSON,
    ValidateMenuOrderItemsResultErrorToJSONTyped,
} from './ValidateMenuOrderItemsResultError';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { DeliveryHandoffInstructions } from './DeliveryHandoffInstructions';
import {
    DeliveryHandoffInstructionsFromJSON,
    DeliveryHandoffInstructionsFromJSONTyped,
    DeliveryHandoffInstructionsToJSON,
    DeliveryHandoffInstructionsToJSONTyped,
} from './DeliveryHandoffInstructions';
import type { MenuOrderItem } from './MenuOrderItem';
import {
    MenuOrderItemFromJSON,
    MenuOrderItemFromJSONTyped,
    MenuOrderItemToJSON,
    MenuOrderItemToJSONTyped,
} from './MenuOrderItem';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { HandoffOptions } from './HandoffOptions';
import {
    HandoffOptionsFromJSON,
    HandoffOptionsFromJSONTyped,
    HandoffOptionsToJSON,
    HandoffOptionsToJSONTyped,
} from './HandoffOptions';
import type { OrderRefund } from './OrderRefund';
import {
    OrderRefundFromJSON,
    OrderRefundFromJSONTyped,
    OrderRefundToJSON,
    OrderRefundToJSONTyped,
} from './OrderRefund';
import type { MenuOrderStatus } from './MenuOrderStatus';
import {
    MenuOrderStatusFromJSON,
    MenuOrderStatusFromJSONTyped,
    MenuOrderStatusToJSON,
    MenuOrderStatusToJSONTyped,
} from './MenuOrderStatus';
import type { MenuOrderDiscount } from './MenuOrderDiscount';
import {
    MenuOrderDiscountFromJSON,
    MenuOrderDiscountFromJSONTyped,
    MenuOrderDiscountToJSON,
    MenuOrderDiscountToJSONTyped,
} from './MenuOrderDiscount';
import type { MenuOrderLog } from './MenuOrderLog';
import {
    MenuOrderLogFromJSON,
    MenuOrderLogFromJSONTyped,
    MenuOrderLogToJSON,
    MenuOrderLogToJSONTyped,
} from './MenuOrderLog';
import type { MenuOrderServiceFee } from './MenuOrderServiceFee';
import {
    MenuOrderServiceFeeFromJSON,
    MenuOrderServiceFeeFromJSONTyped,
    MenuOrderServiceFeeToJSON,
    MenuOrderServiceFeeToJSONTyped,
} from './MenuOrderServiceFee';
import type { OloError } from './OloError';
import {
    OloErrorFromJSON,
    OloErrorFromJSONTyped,
    OloErrorToJSON,
    OloErrorToJSONTyped,
} from './OloError';

/**
 * 
 * @export
 * @interface CreateMenuOrderResponse
 */
export interface CreateMenuOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    business: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    stripeTotal: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    stripeFee?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    marketplaceWithholding?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    tax: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    deliveryCharge: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    tipMerchant?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    tipDelivery?: number;
    /**
     * 
     * @type {Array<MenuOrderDiscount>}
     * @memberof CreateMenuOrderResponse
     */
    discounts?: Array<MenuOrderDiscount>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateMenuOrderResponse
     */
    discountCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    paymentMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    paymentIntentId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    paymentTransferId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    fuelTotal: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    fuel?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    onChainFuelX?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    isMagicWallet?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    fuelTransaction?: string;
    /**
     * USD amount of LootShop credit the user elected to apply to this order (payment tender, Devour-funded). Reduces the card charge (stripeTotal), not merchantOwed.
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    lootShopCreditApplied?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    lootShopCreditTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    fuelRewardsIndustry: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    fuelRewardsIndustryTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    fuelRewardsPayment?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    fuelRewardsPaymentTransaction?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    fuelFiatAtOrderTime?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    experienceRewards?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    experienceRewardsTransaction?: string;
    /**
     * 
     * @type {MenuOrderStatus}
     * @memberof CreateMenuOrderResponse
     */
    status?: MenuOrderStatus;
    /**
     * 
     * @type {Array<MenuOrderLog>}
     * @memberof CreateMenuOrderResponse
     */
    log?: Array<MenuOrderLog>;
    /**
     * 
     * @type {Address}
     * @memberof CreateMenuOrderResponse
     */
    address: Address;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    distance?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    merchantNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    deliveryNotes?: string;
    /**
     * 
     * @type {DeliveryHandoffInstructions}
     * @memberof CreateMenuOrderResponse
     */
    deliveryHandoffInstructions?: DeliveryHandoffInstructions;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    scheduledTime?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    readyBy?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    marketplacePercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    marketplaceFee?: number;
    /**
     * 
     * @type {Array<MenuOrderServiceFee>}
     * @memberof CreateMenuOrderResponse
     */
    serviceFees?: Array<MenuOrderServiceFee>;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    merchantOwed?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    grandTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    transferAmount?: number;
    /**
     * 
     * @type {HandoffOptions}
     * @memberof CreateMenuOrderResponse
     */
    handoff?: HandoffOptions;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    pickupCode?: string;
    /**
     * 
     * @type {Array<MenuOrderItem>}
     * @memberof CreateMenuOrderResponse
     */
    orderItems: Array<MenuOrderItem>;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof CreateMenuOrderResponse
     */
    phoneNumber?: PhoneNumber;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    cancellationReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    stripeCheckout?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    paidToDevour?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    paymentIntent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    chowlyId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    deliveryId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    dspId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    discountSelected?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    discountNullify?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    callbackComplete?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    coinbaseChargeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    isCoinbase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    coinbaseChargeData?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateMenuOrderResponse
     */
    exceededSlippage?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    validationErrorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    devourIqNotification?: string;
    /**
     * 
     * @type {Array<OrderRefund>}
     * @memberof CreateMenuOrderResponse
     */
    refunds?: Array<OrderRefund>;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    uberEatsUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    uberEatsAccountID?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    orderUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    oloBasketId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    oloOrderGuid?: string;
    /**
     * 
     * @type {Array<OloError>}
     * @memberof CreateMenuOrderResponse
     */
    oloErrors?: Array<OloError>;
    /**
     * 
     * @type {object}
     * @memberof CreateMenuOrderResponse
     */
    shippingAddress?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    externalOrderId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    trackingNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMenuOrderResponse
     */
    trackingCarrier?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateMenuOrderResponse
     */
    estimatedDelivery?: number;
    /**
     * 
     * @type {Array<ValidateMenuOrderItemsResultError>}
     * @memberof CreateMenuOrderResponse
     */
    validationErrors?: Array<ValidateMenuOrderItemsResultError>;
}



/**
 * Check if a given object implements the CreateMenuOrderResponse interface.
 */
export function instanceOfCreateMenuOrderResponse(value: object): value is CreateMenuOrderResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    if (!('business' in value) || value['business'] === undefined) return false;
    if (!('subtotal' in value) || value['subtotal'] === undefined) return false;
    if (!('stripeTotal' in value) || value['stripeTotal'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('deliveryCharge' in value) || value['deliveryCharge'] === undefined) return false;
    if (!('fuelTotal' in value) || value['fuelTotal'] === undefined) return false;
    if (!('fuelRewardsIndustry' in value) || value['fuelRewardsIndustry'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('orderItems' in value) || value['orderItems'] === undefined) return false;
    return true;
}

export function CreateMenuOrderResponseFromJSON(json: any): CreateMenuOrderResponse {
    return CreateMenuOrderResponseFromJSONTyped(json, false);
}

export function CreateMenuOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMenuOrderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'currency': json['currency'],
        'customer': json['customer'],
        'business': json['business'],
        'subtotal': json['subtotal'],
        'stripeTotal': json['stripeTotal'],
        'stripeFee': json['stripeFee'] == null ? undefined : json['stripeFee'],
        'marketplaceWithholding': json['marketplaceWithholding'] == null ? undefined : json['marketplaceWithholding'],
        'tax': json['tax'],
        'deliveryCharge': json['deliveryCharge'],
        'tipMerchant': json['tipMerchant'] == null ? undefined : json['tipMerchant'],
        'tipDelivery': json['tipDelivery'] == null ? undefined : json['tipDelivery'],
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(MenuOrderDiscountFromJSON)),
        'discountCodes': json['discountCodes'] == null ? undefined : json['discountCodes'],
        'paymentMethodId': json['paymentMethodId'] == null ? undefined : json['paymentMethodId'],
        'paymentIntentId': json['paymentIntentId'] == null ? undefined : json['paymentIntentId'],
        'paymentTransferId': json['paymentTransferId'] == null ? undefined : json['paymentTransferId'],
        'fuelTotal': json['fuelTotal'],
        'fuel': json['fuel'] == null ? undefined : json['fuel'],
        'onChainFuelX': json['onChainFuelX'] == null ? undefined : json['onChainFuelX'],
        'isMagicWallet': json['isMagicWallet'] == null ? undefined : json['isMagicWallet'],
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'fuelTransaction': json['fuelTransaction'] == null ? undefined : json['fuelTransaction'],
        'lootShopCreditApplied': json['lootShopCreditApplied'] == null ? undefined : json['lootShopCreditApplied'],
        'lootShopCreditTransaction': json['lootShopCreditTransaction'] == null ? undefined : json['lootShopCreditTransaction'],
        'fuelRewardsIndustry': json['fuelRewardsIndustry'],
        'fuelRewardsIndustryTransaction': json['fuelRewardsIndustryTransaction'] == null ? undefined : json['fuelRewardsIndustryTransaction'],
        'fuelRewardsPayment': json['fuelRewardsPayment'] == null ? undefined : json['fuelRewardsPayment'],
        'fuelRewardsPaymentTransaction': json['fuelRewardsPaymentTransaction'] == null ? undefined : json['fuelRewardsPaymentTransaction'],
        'fuelFiatAtOrderTime': json['fuelFiatAtOrderTime'] == null ? undefined : json['fuelFiatAtOrderTime'],
        'experienceRewards': json['experienceRewards'] == null ? undefined : json['experienceRewards'],
        'experienceRewardsTransaction': json['experienceRewardsTransaction'] == null ? undefined : json['experienceRewardsTransaction'],
        'status': json['status'] == null ? undefined : MenuOrderStatusFromJSON(json['status']),
        'log': json['log'] == null ? undefined : ((json['log'] as Array<any>).map(MenuOrderLogFromJSON)),
        'address': AddressFromJSON(json['address']),
        'distance': json['distance'] == null ? undefined : json['distance'],
        'merchantNotes': json['merchantNotes'] == null ? undefined : json['merchantNotes'],
        'deliveryNotes': json['deliveryNotes'] == null ? undefined : json['deliveryNotes'],
        'deliveryHandoffInstructions': json['deliveryHandoffInstructions'] == null ? undefined : DeliveryHandoffInstructionsFromJSON(json['deliveryHandoffInstructions']),
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
        'readyBy': json['readyBy'] == null ? undefined : json['readyBy'],
        'marketplacePercentage': json['marketplacePercentage'] == null ? undefined : json['marketplacePercentage'],
        'marketplaceFee': json['marketplaceFee'] == null ? undefined : json['marketplaceFee'],
        'serviceFees': json['serviceFees'] == null ? undefined : ((json['serviceFees'] as Array<any>).map(MenuOrderServiceFeeFromJSON)),
        'merchantOwed': json['merchantOwed'] == null ? undefined : json['merchantOwed'],
        'grandTotal': json['grandTotal'] == null ? undefined : json['grandTotal'],
        'transferAmount': json['transferAmount'] == null ? undefined : json['transferAmount'],
        'handoff': json['handoff'] == null ? undefined : HandoffOptionsFromJSON(json['handoff']),
        'pickupCode': json['pickupCode'] == null ? undefined : json['pickupCode'],
        'orderItems': ((json['orderItems'] as Array<any>).map(MenuOrderItemFromJSON)),
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
        'stripeCheckout': json['stripeCheckout'] == null ? undefined : json['stripeCheckout'],
        'paidToDevour': json['paidToDevour'] == null ? undefined : json['paidToDevour'],
        'paymentIntent': json['paymentIntent'] == null ? undefined : json['paymentIntent'],
        'chowlyId': json['chowlyId'] == null ? undefined : json['chowlyId'],
        'deliveryId': json['deliveryId'] == null ? undefined : json['deliveryId'],
        'dspId': json['dspId'] == null ? undefined : json['dspId'],
        'discountSelected': json['discountSelected'] == null ? undefined : json['discountSelected'],
        'discountNullify': json['discountNullify'] == null ? undefined : json['discountNullify'],
        'callbackComplete': json['callbackComplete'] == null ? undefined : json['callbackComplete'],
        'coinbaseChargeId': json['coinbaseChargeId'] == null ? undefined : json['coinbaseChargeId'],
        'isCoinbase': json['isCoinbase'] == null ? undefined : json['isCoinbase'],
        'coinbaseChargeData': json['coinbaseChargeData'] == null ? undefined : json['coinbaseChargeData'],
        'exceededSlippage': json['exceededSlippage'] == null ? undefined : json['exceededSlippage'],
        'validationErrorMessage': json['validationErrorMessage'] == null ? undefined : json['validationErrorMessage'],
        'devourIqNotification': json['devourIqNotification'] == null ? undefined : json['devourIqNotification'],
        'refunds': json['refunds'] == null ? undefined : ((json['refunds'] as Array<any>).map(OrderRefundFromJSON)),
        'uberEatsUuid': json['uberEatsUuid'] == null ? undefined : json['uberEatsUuid'],
        'uberEatsAccountID': json['uberEatsAccountID'] == null ? undefined : json['uberEatsAccountID'],
        'orderUuid': json['orderUuid'] == null ? undefined : json['orderUuid'],
        'oloBasketId': json['oloBasketId'] == null ? undefined : json['oloBasketId'],
        'oloOrderGuid': json['oloOrderGuid'] == null ? undefined : json['oloOrderGuid'],
        'oloErrors': json['oloErrors'] == null ? undefined : ((json['oloErrors'] as Array<any>).map(OloErrorFromJSON)),
        'shippingAddress': json['shippingAddress'] == null ? undefined : json['shippingAddress'],
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'trackingCarrier': json['trackingCarrier'] == null ? undefined : json['trackingCarrier'],
        'estimatedDelivery': json['estimatedDelivery'] == null ? undefined : json['estimatedDelivery'],
        'validationErrors': json['validationErrors'] == null ? undefined : ((json['validationErrors'] as Array<any>).map(ValidateMenuOrderItemsResultErrorFromJSON)),
    };
}

export function CreateMenuOrderResponseToJSON(json: any): CreateMenuOrderResponse {
    return CreateMenuOrderResponseToJSONTyped(json, false);
}

export function CreateMenuOrderResponseToJSONTyped(value?: CreateMenuOrderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'currency': value['currency'],
        'customer': value['customer'],
        'business': value['business'],
        'subtotal': value['subtotal'],
        'stripeTotal': value['stripeTotal'],
        'stripeFee': value['stripeFee'],
        'marketplaceWithholding': value['marketplaceWithholding'],
        'tax': value['tax'],
        'deliveryCharge': value['deliveryCharge'],
        'tipMerchant': value['tipMerchant'],
        'tipDelivery': value['tipDelivery'],
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(MenuOrderDiscountToJSON)),
        'discountCodes': value['discountCodes'],
        'paymentMethodId': value['paymentMethodId'],
        'paymentIntentId': value['paymentIntentId'],
        'paymentTransferId': value['paymentTransferId'],
        'fuelTotal': value['fuelTotal'],
        'fuel': value['fuel'],
        'onChainFuelX': value['onChainFuelX'],
        'isMagicWallet': value['isMagicWallet'],
        'transactionHash': value['transactionHash'],
        'fuelTransaction': value['fuelTransaction'],
        'lootShopCreditApplied': value['lootShopCreditApplied'],
        'lootShopCreditTransaction': value['lootShopCreditTransaction'],
        'fuelRewardsIndustry': value['fuelRewardsIndustry'],
        'fuelRewardsIndustryTransaction': value['fuelRewardsIndustryTransaction'],
        'fuelRewardsPayment': value['fuelRewardsPayment'],
        'fuelRewardsPaymentTransaction': value['fuelRewardsPaymentTransaction'],
        'fuelFiatAtOrderTime': value['fuelFiatAtOrderTime'],
        'experienceRewards': value['experienceRewards'],
        'experienceRewardsTransaction': value['experienceRewardsTransaction'],
        'status': MenuOrderStatusToJSON(value['status']),
        'log': value['log'] == null ? undefined : ((value['log'] as Array<any>).map(MenuOrderLogToJSON)),
        'address': AddressToJSON(value['address']),
        'distance': value['distance'],
        'merchantNotes': value['merchantNotes'],
        'deliveryNotes': value['deliveryNotes'],
        'deliveryHandoffInstructions': DeliveryHandoffInstructionsToJSON(value['deliveryHandoffInstructions']),
        'scheduledTime': value['scheduledTime'],
        'readyBy': value['readyBy'],
        'marketplacePercentage': value['marketplacePercentage'],
        'marketplaceFee': value['marketplaceFee'],
        'serviceFees': value['serviceFees'] == null ? undefined : ((value['serviceFees'] as Array<any>).map(MenuOrderServiceFeeToJSON)),
        'merchantOwed': value['merchantOwed'],
        'grandTotal': value['grandTotal'],
        'transferAmount': value['transferAmount'],
        'handoff': HandoffOptionsToJSON(value['handoff']),
        'pickupCode': value['pickupCode'],
        'orderItems': ((value['orderItems'] as Array<any>).map(MenuOrderItemToJSON)),
        'email': value['email'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'errorMessage': value['errorMessage'],
        'cancellationReason': value['cancellationReason'],
        'stripeCheckout': value['stripeCheckout'],
        'paidToDevour': value['paidToDevour'],
        'paymentIntent': value['paymentIntent'],
        'chowlyId': value['chowlyId'],
        'deliveryId': value['deliveryId'],
        'dspId': value['dspId'],
        'discountSelected': value['discountSelected'],
        'discountNullify': value['discountNullify'],
        'callbackComplete': value['callbackComplete'],
        'coinbaseChargeId': value['coinbaseChargeId'],
        'isCoinbase': value['isCoinbase'],
        'coinbaseChargeData': value['coinbaseChargeData'],
        'exceededSlippage': value['exceededSlippage'],
        'validationErrorMessage': value['validationErrorMessage'],
        'devourIqNotification': value['devourIqNotification'],
        'refunds': value['refunds'] == null ? undefined : ((value['refunds'] as Array<any>).map(OrderRefundToJSON)),
        'uberEatsUuid': value['uberEatsUuid'],
        'uberEatsAccountID': value['uberEatsAccountID'],
        'orderUuid': value['orderUuid'],
        'oloBasketId': value['oloBasketId'],
        'oloOrderGuid': value['oloOrderGuid'],
        'oloErrors': value['oloErrors'] == null ? undefined : ((value['oloErrors'] as Array<any>).map(OloErrorToJSON)),
        'shippingAddress': value['shippingAddress'],
        'externalOrderId': value['externalOrderId'],
        'trackingNumber': value['trackingNumber'],
        'trackingCarrier': value['trackingCarrier'],
        'estimatedDelivery': value['estimatedDelivery'],
        'validationErrors': value['validationErrors'] == null ? undefined : ((value['validationErrors'] as Array<any>).map(ValidateMenuOrderItemsResultErrorToJSON)),
    };
}

